import type { ReactNode } from 'react';

import type { Lang } from '../../lib/i18n';

/**
 * A help topic, in both languages.
 *
 * Prose does not go through `t()`. A paragraph is not a label: interpolating it key by key
 * produces English sentences with German clause order, and the two versions need to be
 * free to differ in length and structure — the German text can lean on `§ 25 TDDDG`
 * without a gloss, the English one cannot.
 */
export interface Topic {
  group: GroupId;
  title: Record<Lang, string>;
  /** One line for the index. Says what question the topic answers, not what it covers. */
  teaser: Record<Lang, string>;
  body: Record<Lang, ReactNode>;
}

export type GroupId = 'einrichtung' | 'banner' | 'blockieren' | 'auswertung' | 'konto';

/** Ordered as someone meets them: set a site up, design it, guard it, read it, run it. */
export const GROUPS: { id: GroupId; title: Record<Lang, string> }[] = [
  { id: 'einrichtung', title: { de: 'Einrichtung', en: 'Setup' } },
  { id: 'banner', title: { de: 'Banner', en: 'Banner' } },
  { id: 'blockieren', title: { de: 'Blockieren & Anbieter', en: 'Blocking & vendors' } },
  { id: 'auswertung', title: { de: 'Auswertung & Nachweise', en: 'Analytics & proofs' } },
  { id: 'konto', title: { de: 'Konto', en: 'Account' } },
];
